import { sageBaseIdentityProviderSyncApi as api } from './sageBaseIdentityProviderSyncApi';

export const addTagTypes = ['identity-provider-connection', 'sync'] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes,
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getIdentityProviderConnections: build.query<
                GetIdentityProviderConnectionsApiResponse,
                GetIdentityProviderConnectionsApiArg
            >({
                query: (queryArg) => ({
                    url: `/identity-provider-connections`,
                    headers: { Authorization: queryArg?.authorization },
                    params: { domain: queryArg.domain },
                }),
                providesTags: ['identity-provider-connection'],
            }),
            syncUser: build.mutation<SyncUserApiResponse, SyncUserApiArg>({
                query: (queryArg) => ({
                    url: `/sync/user`,
                    method: 'PUT',
                    body: queryArg.body,
                    headers: { Authorization: queryArg?.authorization },
                }),
                invalidatesTags: ['sync'],
            }),
        }),
        overrideExisting: false,
    });
export { injectedRtkApi as sageIdentityProviderSyncApi };
export type GetIdentityProviderConnectionsApiResponse =
    /** status 200 OK */ IdentityProviderConnection;
export type GetIdentityProviderConnectionsApiArg = {
    authorization?: string;
    /** Associated email domain */
    domain: string;
};
export type SyncUserApiResponse = /** status 200 OK */ {
    profileRid?: string;
    action?: 'CREATE' | 'UPDATE' | 'DELETE' | 'NOOP';
};
export type SyncUserApiArg = {
    authorization?: string;
    body: {
        connectionName?: string;
        email?: string;
    };
};
export type IdentityProviderConnection = {
    /** The name of the Auth0 connection. */
    auth0ConnectionName?: string;
    /** The provider hosting the SAML connection. */
    samlProvider?: 'ENTRA' | 'GENERIC_SAML';
};
export const {
    useGetIdentityProviderConnectionsQuery,
    useLazyGetIdentityProviderConnectionsQuery,
    useSyncUserMutation,
} = injectedRtkApi;
